const headerNavItems = document.querySelectorAll(".header__nav ul li");

if (headerNavItems.length) {
    headerNavItems.forEach((item) => {
        const link = item.querySelector("a");
        const submenu = item.querySelector(".submenu");

        if (submenu) {
            link.addEventListener("mouseenter", () => {
                submenu.classList.add("show");
            });
            link.addEventListener("mouseout", () => {
                submenu.classList.remove("show");
            });
            submenu.addEventListener("mouseenter", () => {
                submenu.classList.add("show");
            });
            submenu.addEventListener("mouseout", () => {
                submenu.classList.remove("show");
            });
        }
    });
}
